import React, { useState } from "react";
import Control from "../../../common/Controls/Control";
import FormContainer from "../../../common/FormContainer/FormContainer";
import useCustomers from "../../../hooks/useCustomers/useCustomers";

const ModifyCustomerPassword = () => {
  const { state, dispatch, customers_actions, customer, customersErrors, isLoading, constants } = useCustomers();

  const [newPassword, setNewPassword] = useState("");

  const handleSubmit = () => {
    customers_actions.modifyCustomerPassword(newPassword);
  };

  return (
    <FormContainer onSubmit={handleSubmit} isLoading={isLoading}>
      <div className="row">
        <div className="col-12">
          <h4>Modifier le mot de passe</h4>
        </div>
        <div className="col-12 col-md-6">
          <Control
            label="Mot de passe"
            type="password"
            name="newPassword"
            value={newPassword}
            change={(e) => setNewPassword(e.target.value)}
            error={customersErrors.password ? { newPassword: customersErrors.password } : {}}
          />
        </div>
      </div>
    </FormContainer>
  );
};

export default ModifyCustomerPassword;
